const AksaraCharModal = ({
  modalChar,
  onClose,
  onBelajar,
  getBarStyle,
  darkMode = false,
}) => {
  if (!modalChar) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
      onClick={onClose}
    >
      <div
        className={`rounded-2xl shadow-xl text-center relative p-5 md:p-8 w-[90vw] max-w-xs min-w-[220px] md:w-[400px] md:max-w-md md:min-w-[320px] lg:w-[400px] lg:max-w-lg lg:min-w-[350px] ${
          darkMode ? "bg-gray-900 text-gray-100" : "bg-white text-gray-800"
        }`}
        style={{
          // Responsive modal height for mobile/tablet
          maxHeight: "90vh",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={`absolute top-2 right-2 text-xl ${
            darkMode
              ? "text-gray-400 hover:text-gray-200"
              : "text-gray-400 hover:text-gray-700"
          }`}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div
          className={`text-5xl mb-2 ${
            darkMode ? "text-gray-100" : "text-gray-800"
          }`}
          style={{ fontFamily: "Noto Sans Batak" }}
        >
          {Array.isArray(modalChar.chars)
            ? modalChar.chars.join(" / ")
            : modalChar.char}
        </div>
        <div
          className={`text-lg font-bold mb-1 ${
            darkMode ? "text-blue-300" : "text-blue-700"
          }`}
        >
          {modalChar.latin}
        </div>
        {/* <div
          className={`text-sm mb-4 ${
            darkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          Example:{" "}
          <span className="font-mono">
            Contoh kata dengan "{modalChar.latin}"
          </span>
        </div> */}
        <div
          className={`w-full h-2 rounded-full overflow-hidden mb-2 ${
            darkMode ? "bg-gray-700" : "bg-gray-300"
          }`}
        >
          <div
            className={`${getBarStyle(
              modalChar.status,
              darkMode
            )} h-2 rounded-full transition-all`}
            style={{
              width: `${Math.round(
                ((modalChar.currentLesson ?? 0) /
                  (modalChar.totalLesson ?? 1)) *
                  100
              )}%`,
            }}
          />
        </div>
        <div
          className={`text-xs mb-1 ${
            darkMode ? "text-gray-400" : "text-gray-500"
          }`}
        >
          Progress: {modalChar.currentLesson}/{modalChar.totalLesson} Lesson
        </div>
        <div
          className={`text-xs mb-4 ${
            darkMode ? "text-gray-400" : "text-gray-500"
          }`}
        >
          Status:{" "}
          <span className="capitalize">
            {modalChar.status === "mastered"
              ? "Mastered"
              : modalChar.status === "active"
              ? "Available"
              : "Not Started"}
          </span>
        </div>
        <button
          className={`mt-2 mx-2 px-6 py-3 rounded font-semibold w-full ${
            darkMode
              ? "bg-lime-600 text-white hover:bg-lime-500"
              : "bg-lime-500 text-white hover:bg-lime-600"
          }`}
          style={{ fontFamily: "DIN Next Rounded" }}
          onClick={onBelajar}
        >
          Belajar
        </button>
      </div>
    </div>
  );
  // ...existing code...
};

export default AksaraCharModal;
